import React from "react";
import Layout from "../../layout/Layout";
import About from "./Sections/About";
import Action from "./Sections/Action";
import Advantages from "./Sections/Advantages";
import Polaroid from "./Sections/Polaroid";
import Pyramid from "./Sections/Pyramid";
import Socials from "./Sections/Socials";
import Solutions from "./Sections/Solutions";
import Steps from "./Sections/Steps";
import Team from "./Sections/Team";
import WhyUs from "./Sections/WhyUs";

const style = {
	mainWrapper: `text-white`,
	sectionTwo: `lg:flex lg:min-h-[50vh] lg:justify-center lg:mt-[20vh] lg:gap-[10vw]`,
	sectionThree: `lg:flex lg:min-h-[50vh] lg:justify-center lg:mt-[20vh] lg:gap-[10vw]`,
	sectionFour: `lg:flex lg:min-h-[50vh] lg:justify-center lg:mt-[20vh] lg:gap-[10vw]`,
	sectionFive: `lg:flex lg:min-h-[50vh] lg:justify-center lg:mt-[20vh] lg:gap-[10vw]`,
};

const Main = () => {
	return (
		<Layout>
			<div className={style.mainWrapper}>
				<About />
				<div className={style.sectionTwo}>
					<Solutions />
					<Pyramid />
				</div>
				<div className={style.sectionThree}>
					<Steps />
				</div>
				<div className={style.sectionFour}>
					<Team />
					<Advantages />
				</div>
				<div className={style.sectionFive}>
					<WhyUs />
					<Action />
				</div>
				<Socials />
			</div>
		</Layout>
	);
};

export default Main;
